// extracted by mini-css-extract-plugin
export default {"wrapper":"CommonButton_wrapper__giUnE","disabledButton":"CommonButton_disabledButton__CMVLy","outlinedButton":"CommonButton_outlinedButton__sNBFg"};